import React, { useContext } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import NotFound from "components/NotFound";
import SettingsMenu from "./Settings";
import { SettingsProvider } from "./SettingsContext";
import AppContext from "AppContext";
import PrivateRoute from "components/PrivateRoute";
import Users from "./Users";
import Modules from "./Modules";
import BusinessHours from "./BusinessHours";
import Status from "./Status";
import Types from "./Types";
import ContactTypes from "./ContactTypes";
import FileLocations from "./FileLocations";
import Flows from "./Flows";
import POSCategories from "./POSCategories";
import InvoicingIssuer from "./InvoicingIssuer";
import Products from "./Products";
import Configurations from "./Configurations";

function Settings() {
    const {
        api: { Settings },
    } = useContext(AppContext);
    return (
        <SettingsProvider value={Settings}>
            <SettingsMenu>
                <Switch>
                    <Redirect exact from="/settings" to="/settings/users" />
                    <PrivateRoute path="/settings/users" component={Users} />
                    <PrivateRoute exact path="/settings/business-hours" component={BusinessHours} />
                    <PrivateRoute exact path="/settings/types" component={Types} />
                    <PrivateRoute exact path="/settings/status" component={Status} />
                    <PrivateRoute exact path="/settings/modules" component={Modules} />
                    <PrivateRoute exact path="/settings/contact-types" component={ContactTypes} />
                    <PrivateRoute exact path="/settings/file-locations" component={FileLocations} />
                    <PrivateRoute path="/settings/flows" component={Flows} />
                    <PrivateRoute exact path="/settings/pos/categories" component={POSCategories} />
                    <PrivateRoute exact path="/settings/documents-issuer" component={InvoicingIssuer} />
                    <PrivateRoute exact path="/settings/services" component={Products} />
                    <PrivateRoute exact path="/settings/system-parameters" component={Configurations} />
                    <Route component={NotFound} />
                </Switch>
            </SettingsMenu>
        </SettingsProvider>
    );
}

export default Settings;
